import { DocumentUploadService } from '@xengage/gw-portals-document-js';
import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class AgentRegistrationService {

    static searchByLicenseNumber(TDIAgencySearchDTO, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'searchByLicenseNumber',
            [TDIAgencySearchDTO],
            additionalHeaders
        );
    }

    static retrieveDocuments(licenseNumber, uwcompany, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'retreiveDocuments',
            [licenseNumber, uwcompany],
            additionalHeaders
        );
    }

    static uploadDocumentTFPA(file, documentMetadata, additionalHeaders = {}) {
        return DocumentUploadService.send(
            getProxiedServiceUrl('agentRegistration'),
            file,
            documentMetadata,
            additionalHeaders
        );
    }

    static generateDownloadToken(licenseNumber, docUID, uwCompany, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'generateDownloadToken',
            [licenseNumber, docUID, uwCompany],
            additionalHeaders
        );
    }

    static deleteDocument(licenseNumber, docUID, uwCompany, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'deleteDocument',
            [licenseNumber, docUID, uwCompany],
            additionalHeaders
        );
    }

    static getDocumentDownloadLink(documentID, token) {
        // DE20434 getDocumentLink function now attempts to download instead of
        // returning a link
        const baseURL = getProxiedServiceUrl('document');
        return `${baseURL}/${documentID}?token=${token}`;
    }

    static submitNewAgent(AgentRegistrationDTO, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'submitNewAgent',
            [AgentRegistrationDTO],
            additionalHeaders
        );
    }

    static createActivationLink(agencySearchDTO, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'createActivationLink',
            [agencySearchDTO],
            additionalHeaders
        );
    }

    static isExpired(token, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('agentRegistration'),
            'isExpired',
            [token],
            additionalHeaders
        );
    }

}
